
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kalender",
      function () {
        return require("private-next-pages/kalender.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kalender"])
      });
    }
  